import { Component, OnInit, ViewChild } from '@angular/core';
import { CalcHeaders } from '../models/calcHeader';
import { CalcService } from '../shared/calc/calc.service';
import { pgiCalcItems } from '../models/pgiCalcItems';
import { pgiAuthors } from '../models/authors';
import { MatTableDataSource, MatPaginator, MatSort } from '@angular/material';
import { UserService } from '../shared/user/user-service.service';
import { PgiNotesAuthor } from '../models/pgiNotesAuthor';
import { AuthorsService } from '../shared/authors/authors.service';
import { ActivatedRoute } from '@angular/router';
import { CoreService } from '../shared/core/core.service';

@Component({
  selector: 'app-calc',
  templateUrl: './calc.component.html',
  styleUrls: ['./calc.component.css']
})
export class CalcComponent implements OnInit {
  static calculations: CalcHeaders[];

  calcItems: pgiCalcItems[];
  authors: pgiAuthors[];

  selectedCalc: CalcHeaders;
  selectedRowIndex = -1;

  // tslint:disable-next-line:max-line-length
  displayedColumns = ['authorName', 'month', 'year', 'salesValue', 'provisionValue', 'correction', 'accountBalance', 'settled', 'isPublished'];
  dataSource: any;

  isLoading = false;
  color = 'primary';
  mode = 'indeterminate';

  userRole = [];
  IsDisable = true;
  notes = '';
  pgiNotesAuthor: PgiNotesAuthor = { id: 0, notes: ''};
  view = 0;
  btn_rozlicz_visible = true;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  // tslint:disable-next-line:max-line-length
  constructor(private calcService: CalcService,
    private userService: UserService,
    private authorService: AuthorsService,
    public route: ActivatedRoute,
    private coreService: CoreService ) {
  }

  ngOnInit() {
    this.getCalc();
  }

  getCalc(): void {

    this.isLoading = true;
    this.view = +this.route.snapshot.paramMap.get('id');

    if (this.view !== 0) {
      this.calcService.getCalcByAuthor(this.view).subscribe((calculations => {
        calculations = calculations;
        this.dataSource = new MatTableDataSource();
        this.dataSource.data = calculations;
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.isLoading = false;
        this.GetUserRole();
        this.GetNotesForAllAuthors();
      }));
    } else {
    this.calcService.getCalc().subscribe((calculations => {
      calculations = calculations;
      this.dataSource = new MatTableDataSource();
      this.dataSource.data = calculations;
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.isLoading = false;
      this.GetUserRole();
      this.GetNotesForAllAuthors();
    }));
    console.log(this.userRole);
  }
  }
  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
  onSelect(calcHeader: CalcHeaders): void {
    this.selectedCalc = calcHeader;
    this.calcItems = this.selectedCalc.pgiCalcItems;
  }


highlight(row) {
    this.selectedRowIndex = row.id;
}

checkRole(): void {
  const res = this.userRole.find(r => r === 'Administrator') != null;
  console.log(this.userRole);
  if (res) {
    this.IsDisable = false;
  } else {
    this.IsDisable = true;
  }
}

isRole() {
  const res = this.userRole.find(c => c === 'Autor') != null;
  if (res) {
    this.GetAuthorNotes();
    console.log(this.notes);
      this.displayedColumns = [ 'authorName', 'month', 'year', 'provisionValue', 'accountBalance'];
      this.btn_rozlicz_visible = false;
    }
}

GetUserRole() {
  this.userService.getUserClaimsRole().subscribe((data: any) => {
    this.userRole = data;
    this.isRole();
    this.checkRole();
    console.log(this.IsDisable);
  });
}

GetNotesForAllAuthors() {
  this.authorService.getNotes().subscribe(result => {
    if (result != null) {
      this.pgiNotesAuthor = result;
    }
    });
}

GetAuthorNotes() {
   this.authorService.getNotesForAuthor().subscribe(result => this.notes = result);
}

rozlicz() {
  const source = this.dataSource.data.filter(x => x.settled === true);
  console.log(source);
    this.authorService.clearAccountBalance(source).subscribe( succes => {
      console.log(succes);
    this.coreService.openSnackBar('Stan konta został wyzerowany.', '');
    this.getCalc();
    }
  );
}

rozliczAll() {
  this.authorService.clearAllAccountBalance().subscribe(succes => {
    this.coreService.openSnackBar('Stany kont powyżej 100 zł zostały wyzerowane.', '');
    this.getCalc();
  }
  );
}
goBack(): void {
  this.coreService.goBack();
}

publishSelected() {
    const source = this.dataSource.data.filter(x => x.isPublished === true);
    // source.forEach(element => {
    //   console.log(element);
    // });
    this.calcService.publishAll(source).subscribe(x => {
      this.coreService.openSnackBar(x, '');
      this.getCalc();
    });
  }

  select() {
    this.dataSource.data.forEach(h => {
        h.isPublished = true;
       });
  }
  unselect() {
    this.dataSource.data.forEach(h => {
        h.isPublished = false;
       });
  }
}

